const state = {
    formData: {
        projectInfo: {}
    }
}

const mutations = {
    SET_FORMDATA(state, data) {
        state.formData[data.key] = data.data
    }
}

export default {
    namespaced: true,
    state,
    mutations
}